import '../App.css';
import img1 from '../img/person-plus-1t-120.png';
import img2 from '../img/list-items-1t-120.png';
import imgdesc1 from '../img/add-new-account.png';
import imgdesc2 from '../img/enter-email.png';
import imgdesc3 from '../img/enter-your-email.png';
import imgdesc4 from '../img/additional-settings.png';
import imgdesc5 from '../img/imap-settings.png';
import imgdesc6 from '../img/smtp-settings.png';


export default function EmailInstructions() {
  return (
    <div className={`Small-content Wide-content`}>
      <h1>Setting up your Email Client</h1>
      <div className={`About-section img-left`}>
        <h2>Add your Email Account</h2>
        <img src={img1} alt="" className="Content-section-side-img" />
        <p className="Content-section-p">
          In your email client app, go into <em>accounts</em> and Add a new Account.
          <br />
          <img src={imgdesc1} alt="" className="Content-section-img" />
        </p>
      </div>
      <div className={`About-section img-left`}>
        <h2>Enter your Email Address</h2>
        <img src="" alt="" className="Content-section-side-img" />
        <p className="Content-section-p">
          Enter your full email address (e.g., user@palnau.us).
          <br />
          Also enter your name and your password.
          <br />
          <img src={imgdesc2} alt="" className="Content-section-img" /><img src={imgdesc3} alt="" className="Content-section-img" />
        </p>
      </div>
      <div className={`About-section img-left`}>
        <h2>Enter additional settings</h2>
        <img src={img2} alt="" className="Content-section-side-img" />
        <p className="Content-section-p">
          In your email client, you will need to add <em>additional settings</em>.
          <br />
          You may need to re-enter your email and password for IMAP / SMTP.
          <br />
          <img src={imgdesc4} alt="" className="Content-section-img" />
        </p>
      </div>
      <div className={`About-section img-left`}>
        <h2>IMAP section</h2>
        <img src="" alt="" className="Content-section-side-img" />
        <p className="Content-section-p">
          Under IMAP settings, enter in these details:
          <br />
          <img src={imgdesc5} alt="" className="Content-section-img" />
        </p>
      </div>
      <div className={`About-section img-left`}>
        <h2>SMTP Section</h2>
        <img src="" alt="" className="Content-section-side-img" />
        <p className="Content-section-p">
          For SMTP (Outbound), enter these details:
          <br />
          <img src={imgdesc6} alt="" className="Content-section-img" />
        </p>
      </div>
      <div className={`About-section`}>
        <h2>All good!</h2>
        <p className="Content-section-p">
          You should now be able to use your email client. To manage your filters and password, go to <a href="https://mailboxes.dreamhost.com" className="App-link" target="_blank" rel="noreferrer">mailboxes.dreamhost.com</a>.
          <br />
          <br />
          Also, to set a picture that shows with your email user, make a Gravatar account at <a href="https://gravatar.com" className="App-link" target="_blank" rel="noreferrer">gravatar.com</a> using the same email address.
        </p>
      </div>
    </div>
  );
}